import { LuPencilLine, LuTrash2 } from 'react-icons/lu';
import type { NewsArticle } from '../../schema';

interface Props {
  row: NewsArticle;
  onEdit: (row: NewsArticle) => void;
  onDelete: (row: NewsArticle) => void;
}

export function RowActions({ row, onEdit, onDelete }: Props) {
  return (
    <div className="row-actions flex h-full items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onEdit(row)}
        aria-label={`Edit ${row.title}`}
        title="Edit"
        className="group flex h-8 w-8 shrink-0 items-center justify-center self-center rounded-lg bg-primary/[0.08] text-primary ring-1 ring-inset ring-primary/15 transition-all duration-200 hover:scale-110 hover:bg-primary hover:text-primary-foreground hover:shadow-[0_4px_12px_-2px_rgb(var(--color-primary)/0.4)]"
      >
        <LuPencilLine size={15} strokeWidth={2.2} />
      </button>
      <button
        type="button"
        onClick={() => onDelete(row)}
        aria-label={`Delete ${row.title}`}
        title="Delete"
        className="group flex h-8 w-8 shrink-0 items-center justify-center self-center rounded-lg bg-danger/[0.08] text-danger ring-1 ring-inset ring-danger/15 transition-all duration-200 hover:scale-110 hover:bg-danger hover:text-white hover:shadow-[0_4px_12px_-2px_rgb(var(--color-danger)/0.4)]"
      >
        <LuTrash2 size={15} strokeWidth={2.2} />
      </button>
    </div>
  );
}
